/**
 * @desc 根据MSKU和店铺获取对应的FNSKU
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.mskuFacadeImpl.loadFnskuByMskuAndShopCode.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/msku/loadFnskuByMskuAndShopCode`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
